import React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';

interface NotAwardProps {
    desc?: string;
    open?: boolean;
    onCancel?: () => void;
}

const NotAward: React.FC<NotAwardProps> = ({ open, onCancel, desc }) => {
    const { useLang } = useGlobal();
    const { t } = useLang('ecocredits');

    return (
        <EfModal centered className={css.efmodal} visible={open} zIndex={1200} onCancel={onCancel}>
            <div className="text-content">
                <p className="text">{desc}</p>

                <Button onClick={onCancel} className="m-btn">
                    {t('confirm_btn_text')}
                </Button>
            </div>
        </EfModal>
    );
};

export default NotAward;
